import { MgItemCard, Supplier } from '@retail/products/types';
import { MgItemDetails } from './MgItemDetails';
import { useNavigate } from 'react-router';
import { Link, Paper, Stack, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useProductsTFunction } from '@retail/products/i18n';
import { useDisclosure } from '@shared/hooks';
import AddItemToAssortment from './AddItemToAssortment';
import { useMonitoringAssortments } from '@retail/monitoring-assortment/context';

interface Props {
  mgItem: MgItemCard;
  hiddenBreadcrumbs?: boolean;
  showMonitorItem?: boolean;
  showAddItem?: boolean;
}

export function MgItemContainer({
  mgItem,
  hiddenBreadcrumbs = false,
  showMonitorItem,
  showAddItem,
}: Props) {
  const t = useProductsTFunction();
  const navigate = useNavigate();

  const { monitoringAssortments, baseAssortmentId } = useMonitoringAssortments();

  const {
    isOpen: isSelectItemModalOpen,
    onOpen: openSelectItemModal,
    onClose: closeSelectItemModal,
  } = useDisclosure(false);

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
        pt: hiddenBreadcrumbs ? 1 : 0,
      }}
    >
      {!hiddenBreadcrumbs && (
        <Link color="textPrimary" onClick={() => navigate(-1)} sx={{ cursor: 'pointer' }}>
          <Stack flexDirection="row" alignItems="center" p={1} pb={0}>
            <ArrowBack fontSize="small" sx={{ height: 16 }} />
            <Typography variant="body2">{t('products.mgItem.notFound.goBack')}</Typography>
          </Stack>
        </Link>
      )}

      <MgItemDetails
        mgItem={mgItem}
        assortmentId={baseAssortmentId}
        monitoringAssortments={monitoringAssortments}
        showMonitorItem={showMonitorItem}
        showAddItem={showAddItem}
        openSelectItemModal={openSelectItemModal}
      />

      {isSelectItemModalOpen && (
        <AddItemToAssortment
          open
          mgItemNumber={mgItem.mgItemNumber}
          availableSuppliers={
            mgItem.mgSupplierItems.map((supplierItem) => {
              return {
                name: supplierItem.mgSupplier.name,
                id: supplierItem.mgSupplier.mgSupplierId,
              };
            }) as Supplier[]
          }
          onClose={closeSelectItemModal}
        />
      )}
    </Paper>
  );
}
